// removed by extract-text-webpack-plugin
module.exports = {"fullWidth":"KE1DVAZ-lCdQb-Ru2D2fz","CodeField":"_2-cWpQsJ3EDVDKzH-RYX82","HideCaret":"_1FZXUjqTVYzypo8es7gzQV","Impostor":"_1vMgSmq9vDgsuRnlC3YqoF","error":"_2cvnEXqIxoL8QlTocrSbE5","ErrorText":"_3XUtd0iis8FPokdKCxpEax"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CodeField/index.css
// module id = 499
// module chunks = 0